import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/styles";
import { Instance } from "../../types/whatsapp";
import { Autocomplete } from "../Autocomplete";
import { useEffect, useState } from "react";
import CloseIcon from "../../assets/icons/closeIcon.png";

const Img = styled("img")({});

interface ContactUpdateProps {
  open: boolean;
  instances: Instance[];
  onClose: () => void;
  onSave: (idInstance: number) => void;
}

export function ContactsActivate(props: ContactUpdateProps) {
  const { open, instances, onClose, onSave } = props;

  const [instanceActivateContacts, setInstanceActivateContacts] =
    useState<Instance | null>(null);
  const [onErrorInstanceAutoComplete, setOnErrorInstanceAutoComplete] =
    useState<boolean>(false);
  const [isCheckedWhatsapp, setIsCheckedWhatsapp] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<string>("");

  useEffect(() => {
    setInstanceActivateContacts(instances[0]);
  }, [instances]);

  const handleSaveContact = (e: any) => {
    e.preventDefault();
    if (
      instanceActivateContacts &&
      isCheckedWhatsapp &&
      instanceActivateContacts.shared_instance
    ) {
      onSave(instanceActivateContacts.id!);
    } else {
      if (!Boolean(instanceActivateContacts)) {
        setOnErrorInstanceAutoComplete(true);
      }

      if (!isCheckedWhatsapp) {
        setMessageError("Aceite a política de privacidade do whatsapp.");
      } else if (!instanceActivateContacts?.shared_instance) {
        setMessageError(
          "A instância precisa estar conectada para realizar a sincronização."
        );
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={"sm"}>
      <Box p="32px" component={"form"} onSubmit={handleSaveContact}>
        <DialogTitle sx={{ p: 0 }} fontSize="1.5rem">
          Sincronizar contatos
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          <Box display="flex" flexDirection="column" p="32px 0" gap={3}>
            <Autocomplete
              fullWidth
              size="medium"
              label="Selecione a instância"
              name="instance"
              options={instances}
              value={instanceActivateContacts}
              getOptionLabel={(option) => option.nome}
              onChange={(_, instance) => {
                setOnErrorInstanceAutoComplete(false);
                setInstanceActivateContacts(instance);
              }}
              helperText="Indique qual instancia você deseja ativar os contatos."
              error={Boolean(onErrorInstanceAutoComplete)}
            />
          </Box>

          <Box
            display="flex"
            flexDirection="row"
            border={"1px solid #E79831"}
            borderRadius={"2px"}
            sx={{
              background: "#FDFAE6",
              padding: "0.5rem 1rem",
            }}
          >
            <Img src={CloseIcon} width={"14px"} height={"14px"} />
            <Typography
              ml={"0.5rem"}
              fontWeight={500}
              fontSize={"12px"}
              lineHeight={"22px"}
            >
              Atenção! Enviar mensagens de Whatsapp sem consentimento dos
              usuários viola as regras de política de privacidade do Whatsapp e
              pode acarretar em um possível banimento do seu número de Whatsapp.
            </Typography>
          </Box>
          <Box color={"#616161"} marginTop={"2.25rem"} mb={"1rem"}>
            <Typography fontWeight={500} fontSize={"12px"} lineHeight={"24px"}>
              Ao concordar com esta opção, você está de acordo com a política de
              privacidade do Whatsapp. A Datasales não se resposabiliza por
              quaisquer danos ocorridos por disparos que violam a política de
              privacidade do Whatsapp.
            </Typography>
          </Box>
          <Box
            display={"flex"}
            flexDirection={"row"}
            mb={"1rem"}
            alignItems={"flex-end"}
          >
            <Checkbox
              value={isCheckedWhatsapp}
              onChange={(_, checked) => {
                setIsCheckedWhatsapp(checked);
              }}
            />
            <Typography
              fontWeight={500}
              fontSize={"14px"}
              lineHeight={"17.07px"}
              color={"#616161"}
            >
              Estou ciente e concordo com a política de privacidade do Whatsapp.
            </Typography>
          </Box>

          {messageError && (
            <Box
              mb={"1rem"}
              display="flex"
              flexDirection="row"
              border={"1px solid #FFCCC7"}
              borderRadius={"2px"}
              sx={{
                background: "#FFF1F0",
                padding: "0.5rem 1rem",
              }}
            >
              <Typography
                ml={"0.5rem"}
                fontWeight={500}
                fontSize={"12px"}
                lineHeight={"22px"}
              >
                {messageError}
              </Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions
          sx={{ p: 0, display: "flex", justifyContent: "space-between" }}
        >
          <Button color="inherit" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="contained" type="submit">
            Ativar
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
